import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import ViewStateContainer from 'routes/Documents/containers/ViewStateContainer';

import Medication from '../components/Medication';

class MedicationContainer extends Component {
  render() {
    const { edit, create } = this.props;

    return (
      <DocumentLoader names={['medication', 'vitamin']}>
        <DocumentProvider>
          <ViewStateContainer>
            <Medication onStartEdit={edit} onCreate={create} />
          </ViewStateContainer>
        </DocumentProvider>
      </DocumentLoader>
    );
  }
}

MedicationContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  MedicationContainer,
);
